import { courseList,cityList,servicecentersList,getmessage,getcompany,userLogin,userInfo,registers,demandList,getPVUV } from '@apis/apis'
import Head from '@wigets/head.vue'
import Foot from '@wigets/foot.vue'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
import parksMap from '../services/map/servicesMap.vue'

export default {
  name: 'services',
  data() {
    let validPhone = (rule, value, next) => {
      rule = /^1[23456789]\d{9}$/
      if (!rule.test(value)) {
        return next(new Error('手机号违法'))
      }
      next()
    }
    let validDemand = (rule, value, next) => {
      rule = /\d/
      if (!rule.test(value)) {
        return next(new Error('预算金额为纯数字，不可出现小数'))
      }
      next()
    }
    return {
      //服务商列表
      companyList:[],
      //需求分类
      demandType: [],
      demandLittleType:[],
      //一级分类
      index1: 0,
      index2:0,
      tab: 2,
      //精品课程过度动画参数
      hover: 0,
      //城市tab参数
      active: 0,
      //服务中心列表中心加载动画参数
      loading: true,
      //总视频列表
      videoList:[],
      //精品课程列表
      coursesRankList: [],
      //课程列表
      coursesList: [],
      //服务中心列表
      servicecentersList: [],
      page: 1,
      getinterval: '',
      //当前点击的模块
      checked: 1,
      //遮罩层显示
      logins: false,
      //二维码图片地址
      picPath: '',
      //手机验证码等待时间
      clickMessage: 0,
      //短信验证的按钮显示的信息
      getmessages: '短信验证',
      //注册表单显示
      registers: false,
      actives: 1,
      //需求请求
      demandList:[],
      //用户手机号及验证码
      users: {
        phone: '',
        key: '',
        userType:3,
      },
      //用户编码，保证用户与验证码一一对应
      ticket: '',
      UserRule: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validPhone, trigger: 'blur' },
        ],
        key: [
          { required: true, message: '验证码不能为空', trigger: 'blur' },
        ],
      },
      //用户需求表单
      userRequest: {
        title:'',
      },
      //用户需求表单验证
      userRequestRule: {
        title: [
          { required: true, message: '请输入需求的名称', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validPhone, trigger: 'blur' },
        ],
        demand: [
          { required: true, message: '请输入预算', trigger: 'blur' },
          { validator: validDemand, trigger: 'blur' },
        ],
        describe: [
          { required: true, message: '请输入需求描述', trigger: 'blur' },
        ]
      }
    }
  },

  filters: {
    getplayCount: function (value) {
      if (!value) return 0
      if (parseInt(value) >= 10000) {
        let str = (value / 10000).toFixed(1) + '万'
        return str
      }
      return value
    }
  },
  
  mounted() {
    //精品课程数据请求
    this.coursesRank()
    //服务中心城市请求
    this.cities()
  },
  created() {
    this.changev()
    this.getpvuv()
  },
  computed: {
    calcNav() {
      let path = this.$route.path;
      let pathName;
      switch(path) {
      case '/services/courses':
        pathName = '课程资源';
        break;
      case '/services/getnewNeed':
        pathName = '发布需求';
        break;
      case '/services/company':
        pathName = '推荐服务商';
        break;
      default:
        pathName = ''
      }

      return pathName;
    }
  },
  methods: {
    //埋点
    getpvuv(){
      this.$ajaxPost(getPVUV,{
        ip: sessionStorage.getItem('ip'),
        directoryOne: "服务体系",
        directoryTwo: null,
        directoryThree: null,
        cookie: sessionStorage.getItem('random')
      })
    },
    //获取checked
    changev(v) {
      if (!v) {
        this.checked=1
      } else {
        this.checked = v
      }
    },
    //跳转到所有需求
    navtoAllServer() {
      this.$router.push({name:'servicesAll'})
    },
    //获取推荐商
    getcompany() {
      this.$ajaxGet(`${getcompany}?page=1&&limit=6`, {}, this.users).then(res => {
        if (res.data.code != 0) {
          this.$message({
            title: "错误",
            type: "error",
            message: res.data.msg + ",请重新刷新",
          })
          return
        }else{
          this.companyList = res.data.data.list
          console.log( this.companyList);
        }
      }).catch(err => {
        this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
          confirmButtonText: '确定',
          type: "error",
        })
      })
    },
    //修改二级分类
    changeLittleType(index) {
      this.index2=index
    },
    //修改一级分类
    changeFirstType(index) {
      this.index1 = index
      this.demandLittleType = this.demandType[this.index1].companyServiceTypeList
      this.index2=0
    },
    //获得需求分类列表
    getdemandType(){
      this.$ajaxGet(`${demandList}`, {
      }).then(res => {
        if (res.data.code != 0) {
          this.$message({
            title: "错误",
            type: "error",
            message: res.data.msg + ",请重新刷新",
          })
          return
        }
        this.demandType = JSON.parse(JSON.stringify(res.data.data))
        this.demandLittleType = this.demandType[this.index1].companyServiceTypeList
        console.log(this.demandType);
      }).catch(err => {
        this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
          confirmButtonText: '确定',
          type: "error",
        })
      })
    },
    //导航到推荐商
    navToenterprise(id) {
      this.$router.push({name:'ServicesEnterPrise',query:{id}})
    },
    //导航去服务详情
    navToServicesInfo(id) {
      this.$router.push({name:'ServicesInfo',query:{id}})
    },
    //点击提交需求
    validatorForm(form) {
      this.$refs[form].validate((valid) => {
        if (!valid) {
          this.$message({
            title: "错误",
            type: "error",
            message: "请正确填写需求内容",
          })
        }
      })
    },
    //点击提交注册
    validForm(formName){
      this.$refs[formName].validate((valid) => {
        if(!valid){
          this.$message({
            title: "错误",
            type: "error",
            message: "请正确填写信息",
          })
        }else{
          this.$ajaxPost(`${registers}`, {}, this.users).then(res => {
            if(res.data.code==201){
              this.$message({
                title: "错误",
                type: "error",
                message:"手机号重复,请重新输入",
              })
              return
            } else {
              if(res.data.code==500){
                this.$message({
                  title: "错误",
                  type: "error",
                  message:"验证码错误,请重新填写",
                })
                return
              }
              if (res.data.code != 0) {
                this.$message({
                  title: "错误",
                  type: "error",
                  message: res.data.msg + ",请重新刷新",
                })
                return
              }else{
                sessionStorage.setItem('token', res.data.data.token)
                this.getuserNew(res.data.data.openid)
              }
            }
          }).catch(err => {
            this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
              confirmButtonText: '确定',
              type: "error",
            })
          })
        }
      });
    },
    //获取用户信息
    getuserNew(openid){
      this.$ajaxGet(`${userInfo}${openid}`, {
      }).then(res => {
        if (res.data.code != 0) {
          this.$message({
            title: "错误",
            type: "error",
            message: res.data.msg + ",请重新刷新",
          })
          return
        }
        this.$message({
          title: "成功",
          type: "success",
          message: "登陆成功",
        })
        this.userInfo=res.data.data
        this.logins=false
        this.registers=false
        sessionStorage.setItem('user-login', JSON.stringify(this.userInfo))
        this.$router.go(0)
      }).catch(err => {
        this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
          confirmButtonText: '确定',
          type: "error",
        })
      })
    },
    //上一步下一步
    changestops(v) {
      if (v == 1) {
        this.actives++
      } else {
        this.actives--
      }
    },
    //更换用户类型
    changeType(v){
      this.users.userType=v
    },
    //获取短信验证码
    getMbmessage(){
      let reg=/^1[23456789]\d{9}$/
      if(!reg.test(this.users.phone)){
        this.$message({
          title: "错误",
          type: "error",
          message: "请正确填写手机号码",
        })}else{
        //点击后60s之后才能获取信息
        this.clickMessage=60
        this.getmessages=`请在${this.clickMessage}s后重试`
        clearInterval(this.setIntervalMessage)
        this.setIntervalMessage=setInterval(() => {
          this.clickMessage--
          this.getmessages=`请在${this.clickMessage}s后重试`
          if(this.clickMessage==0){
            clearInterval(this.setIntervalMessage)
            this.getmessages=`短信验证`
          }
        }, 1000);
        //发送验证码
        this.$ajaxPost(`${getmessage}`,{}, {phone:this.users.phone}).then(res => {
          if(res.data.code!=0){
            this.$message({
              title: "错误",
              type: "error",
              message: "网络错误，请重新刷新",
            })
          }
        }).catch(err => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: '确定',
            type: "error",
          })
        })
      }
    },
    //网页长连接保证用户登录
    getconnect(){
      let that=this
      // 判断浏览器是否支持WebSocket
      let is_support = ("WebSocket" in window);
      if (is_support) {
        // 打开一个 web socket
        let ws = new WebSocket(`${userLogin}/${that.ticket}`);
        ws.onopen = function() { 
          ws.send(that.ticket);
        };
        //  Web Socket 已连接上
        //  接受服务器数据
        ws.onmessage = function(e) {
          let received_msg=JSON.parse(e.data)
          if((received_msg.openid||received_msg.token)&&(received_msg.openid!=='null'||received_msg.token!=='null')){
            let received = received_msg
            if (received.token != "null" && received.token !== '') {
              that.getuserNew(received.openid)
              sessionStorage.setItem('token',received.token)
            } else {
              that.users.openid = received.openid
              that.registers=true
            }
            ws.close();  
          }
        };
        //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。  
        window.onbeforeunload = function(){  
          ws.close();  
        };
      }else{
        this.$alert( "浏览器版本过低，请更新浏览器", "警告", {
          confirmButtonText: '确定',
          type: "error",
        })
      }
    },
    //关闭遮罩层
    nologin() {
      this.logins = false
      let logins = sessionStorage.getItem('user-login')
      if (!logins) {
        this.checked=1
      }
    },
    //点击切换显示内容
    changeChecked(v){
      this.checked = v
      if (v == 1) {
        this.$router.push({name:'videos'})
      }
      if (v == 2) {
        this.$router.push({name:'serverCenter'})
      }
      if (v == 3) {
        this.$router.push({name:'serverHome'})
      }
      // if (this.checked == 3) {
      //   this.$ajaxGet(`${demand}?limit=6&&page=1`, {
      //   }).then(res => {
      //     if (res.data.code != 0) {
      //       this.$message({
      //         title: "错误",
      //         type: "error",
      //         message: res.data.msg + ",请重新刷新",
      //       })
      //     }
      //     this.demandList = res.data.data.list
      //   }).catch(err => {
      //     this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
      //       confirmButtonText: '确定',
      //       type: "error",
      //       callback: () => {
      //         location.reload()
      //       }
      //     })
      //   })
      //   this.getcompany()
      // }
      // if (this.checked == 4) {
      //   this.actives=1
      //   let logines = sessionStorage.getItem('user-login')
      //   if (!logines) {
      //     this.registers=false
      //     this.logins = true
      //     this.$ajaxGet(`${login}`, {
      //     }).then(res => {
      //       if (res.data.code != 0) {
      //         this.$message({
      //           title: "错误",
      //           type: "error",
      //           message: res.data.msg + ",请重新刷新",
      //         })
      //       }
      //       this.picPath=res.data.msg
      //       let arr =res.data.msg.split('=')
      //       this.ticket=arr[1]
      //       this.getconnect()
      //     }).catch(err => {
      //       this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
      //         confirmButtonText: '确定',
      //         type: "error",
      //         callback: () => {
      //           location.reload()
      //         }
      //       })
      //     })
      //   } else {
      //     this.getdemandType()
      //   }
      // }
    },
    //点击位置导航进行跳转
    navPosition(name){
      this.$router.push({name})
    },

    /**
     * @description: 点击查看视频
     * @param {*}
     */
    navToVideo(id) {
      this.$router.push({name:'ServicesVideo',query:{id}})
    },

    /**
     * @description: 精品课程过度动画
     * @param {*}
     */
    coursesIn(val){
      this.hover=val
    },
    coursesOut(){
      this.hover=0
    },

    /**
     * @description: 切换城市tabs 
     * @param {*} this.servicecenters(code)渲染相应服务中心
     * *@param {*} this.loading 为加载动画参数
     */
    cityChange(key, code) {
      this.loading = true
      this.active = key
      this.servicecenters(code)
    },


    renderProducts() {
      let that =this
      new Swiper ('.swiperVideos', {
        slidesPerView : 4,
        spaceBetween : 20,
        observer:true,
        observeParents: true,
        preventClicks: false,
        on: {
          touchEnd: function () {
            let videoBox = document.getElementsByClassName('swiperVideos')
            if (videoBox[0].clientWidth >= videoBox[0].scrollWidth) {
              that.page++
              if (that.page > that.pageAll) {
                return
              } else {
                that.coursesRanks()
              }
            }
          },
        },
      })
    },  
    /**
     * @description: 精品课程数据请求
     * @param {*}
     */
    coursesRank() {
      this.$ajaxPost(`${courseList}`, {
        limit: 15,
        page: this.page,
      })
        .then((res) => {
          if (res.data.code != 0) {
            this.$message({
              title: "错误",
              type: "error",
              message: res.data.msg + ",请重新刷新",
            });
          } else {
            this.videoList = res.data.data.list;
            let totalCount = res.data.data.totalCount;
            this.pageAll = Math.ceil(totalCount / 15);
            let list1 = this.videoList.slice(0, 7);
            let list2 = this.videoList.slice(7);
            this.coursesRankList = list1;
            this.coursesList = list2;
            this.renderProducts();
          }
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
          });
        });
    },

    /**
     * @description: 精品课程数据请求
     * @param {*}
     */
    coursesRanks() {
      this.$ajaxPost(`${courseList}`, {
        limit: 15,
        page:this.page
      }).then(res => {
        if(res.data.code!=0){
          this.$message({
            title: "错误",
            type:"error",
            message:res.data.msg + ",请重新刷新",
          })
        } else {
          this.coursesList = [...this.coursesList, ...this.dateChecked(res.data.data.list)]
          this.renderProducts();
        }
      }).catch(err => {
        this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
          confirmButtonText: '确定',
          type:"error",
        })
      })
    },
    /**
     * @description: 服务中心的城市请求
     * @param {*}17为固定参数 varCode为下一步需要查询的cityCode
     */
    cities() {
      this.$ajaxGet(`${cityList}/17`,{}).then(res => {
        if(res.data.code!=0){
          this.$message({
            title: "错误",
            type:"error",
            message:res.data.msg + ",请重新刷新",
          })
        } else {
          this.cityList = res.data.data
          // console.log(this.cityList)
          let code = this.cityList[0].id
          this.active = code
          this.servicecenters(this.cityList[0].varCode)
        }
      }).catch(err => {
        this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
          confirmButtonText: '确定',
          type:"error",
        })
      })
    },
    /**
     * @description:各城市的服务中心请求
     * @param {*} 根据cityCode查询
     */
    servicecenters(code) {
      this.$ajaxPost(`${servicecentersList}?cityCode=${code}`,{cityCode:code}).then(res => {
        if(res.data.code!=0){
          this.$message({
            title: "错误",
            type:"error",
            message:res.data.msg + ",请重新刷新",
          })
        } else {
          this.servicecentersList = res.data.data.list
          this.loading = false
        }
      }).catch(err => {
        this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
          confirmButtonText: '确定',
          type:"error",
        })
      })
    },
    changeTab(val) {
      this.tab = val
    },
    /**
     * @description: 对后端数据返回的日期 年月日截取
     * @param {*}
     */    
    dateChecked(list){
      for(let i in list){
        list[i].createTime = list[i].createTime.split(" ")[0]
        list[i].id=Number(list[i].id)
      }
      return list
    },
  },

  components: {
    'web-head': Head,
    'web-foot': Foot,
    'parksMap': parksMap,
  }
}